import { render } from "./BaseSportView.vue?vue&type=template&id=1ab20ce7&scoped=true"
import script from "./BaseSportView.vue?vue&type=script&lang=js"
export * from "./BaseSportView.vue?vue&type=script&lang=js"

import "./BaseSportView.vue?vue&type=style&index=0&id=1ab20ce7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab20ce7"]])

export default __exports__